import cls from 'classnames';

const styles = {
  wrapper: (isListItem: boolean, hasInvertedThemeColor: boolean) =>
    cls(
      'inline-flex items-center max-w-full bg-black-light hover:bg-gray-1 hover:text-white tlight:hover:bg-red-light-darker teair:text-air-mediumBlue',
      !hasInvertedThemeColor &&
        'teair:bg-air-lemon teair:text-air-mediumBlue teair:hover:bg-air-lemon-light',
      !isListItem ? 'rounded-8 p-1 pr-4' : 'px-2 py-3',
    ),
};

export default styles;
